var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D4D4",
    d: "M13.333 28.625v-17.25q0-.708.5-1.188.501-.48 1.167-.479a1.7 1.7 0 0 1 .875.25l13.583 8.625q.375.25.564.625t.186.792q0 .417-.186.792-.187.375-.564.625l-13.583 8.625a1.8 1.8 0 0 1-.437.188 1.632 1.632 0 0 1-1.605-.418q-.5-.48-.5-1.187"
  })));
};
export default SvgPlay;